import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../../contexts/LanguageContext';

const LanguageToggle = ({ compact = false, className = '' }) => {
  const { lang, setLanguage } = useLanguage();

  return (
    <div
      className={`inline-flex items-center gap-1 rounded-full border border-black/10 dark:border-white/15 bg-white/70 dark:bg-white/5 backdrop-blur-sm p-0.5 ${className}`}
      role="group"
      aria-label="Language"
    >
      <button
        type="button"
        onClick={() => setLanguage('fr')}
        className={`relative px-3 py-1 text-xs font-semibold uppercase tracking-wider rounded-full transition-colors ${
          lang === 'fr' ? 'text-white' : 'text-black/60 dark:text-white/60 hover:text-black dark:hover:text-white'
        }`}
        aria-pressed={lang === 'fr'}
      >
        {lang === 'fr' && (
          <motion.span
            layoutId="lang-pill"
            className="absolute inset-0 bg-gofit-red rounded-full"
            transition={{ type: 'spring', stiffness: 400, damping: 30 }}
          />
        )}
        <span className="relative">FR</span>
      </button>
      <button
        type="button"
        onClick={() => setLanguage('ar')}
        className={`relative px-3 py-1 text-xs font-semibold rounded-full transition-colors ${
          lang === 'ar' ? 'text-white' : 'text-black/60 dark:text-white/60 hover:text-black dark:hover:text-white'
        }`}
        style={{ fontFamily: '"Cairo", "Tajawal", sans-serif' }}
        aria-pressed={lang === 'ar'}
      >
        {lang === 'ar' && (
          <motion.span
            layoutId="lang-pill"
            className="absolute inset-0 bg-gofit-red rounded-full"
            transition={{ type: 'spring', stiffness: 400, damping: 30 }}
          />
        )}
        <span className="relative">{compact ? 'ع' : 'عربي'}</span>
      </button>
    </div>
  );
};

export default LanguageToggle;
